export default {"src":"/_next/static/media/icon-office.1f709fd7.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};